module.exports = __webpack_public_path__ + "img/mp4.5abe45cd.png";